import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";
import { DateRangePicker, createStaticRanges , defaultStaticRanges  } from "react-date-range";
import moment from "moment";

class ExportFilterModal extends React.Component {
    state = {
    	selectionRange: {
    		selection: {
    			startDate: null,
    			endDate:  null,
    			key: "selection"
    		}
    	},
    	filters: {}
    }

    getFormatedRange = () => {
    	const { startDate, endDate } = this.state.filters;
    	if(startDate && endDate) {
    		return {
    			startDate: moment(startDate).format("YYYY-MM-DD"),
    			endDate: moment(endDate).format("YYYY-MM-DD")
    		};
    	}
    	return { startDate: null, endDate: null };
    }

    getExtraStaticRange = () => [
    	...createStaticRanges([
    		{
    			label: "All",
    			range: () => ({
    				startDate: moment("1918-01-01"),
    				endDate: moment()
    			}),
    		}
    	]),
    	...defaultStaticRanges,
    ]

    handleDateRange = (range) => {
    	this.setState({
    		selectionRange: { 
    			...this.state.selectionRange, 
    			...range 
    		},
    		filters: {
    			...this.state.filters,
    			startDate: moment(range.selection.startDate),
    			endDate: moment(range.selection.endDate)
    		}
    	});
    }

    clearRange = () => {
    	this.setState({
    		selectionRange: { 
    			...this.state.selectionRange, 
    			selection: {
    				startDate: null,
    				endDate: null,
    				key: "selection"
    			}
    		},
    		filters: {
    			startDate: null,
    			endDate: null
    		}
    	});
    }

    render () {
    	console.log(this.state);
    	const { startDate, endDate } = this.getFormatedRange();
    	const extraStaticRange = this.getExtraStaticRange();
    	return (
    		<Modal className="export-filter-modal" show={this.props.showExportModal} onHide={this.props.handleExportModal}>
    			<Modal.Header>
    				<button type="button" className="close btn-close-modal" aria-hidden="true" onClick={this.props.handleExportModal}>&times;</button>
    				<Modal.Title>Select export date range ?</Modal.Title>
    			</Modal.Header>
    
    			<Modal.Body>
    				<Button type="button" bsStyle="default" onClick={this.clearRange}>Reset</Button>
    				<hr/>
    				<DateRangePicker
    					onChange={this.handleDateRange}
    					showSelectionPreview
    					moveRangeOnFirstSelection={false}
    					className={"PreviewArea"}
    					months={1}
    					staticRanges={extraStaticRange}
    					ranges={[this.state.selectionRange.selection]}
    					direction="horizontal"
    				/>
    			</Modal.Body>
    
    			<Modal.Footer>
    				<Button bsStyle="success" className="btn-min" onClick={()=> this.props.exportToExcel(startDate, endDate)}>Export</Button>
    				<Button bsStyle="default" className="btn-min" onClick={this.props.handleExportModal}>Close</Button>
    			</Modal.Footer>
    		</Modal>
    	);
    }
};

ExportFilterModal.defaultProps = {

};

ExportFilterModal.propTypes = {
	showExportModal: PropTypes.bool.isRequired,
	handleExportModal: PropTypes.func.isRequired,
	exportToExcel: PropTypes.func.isRequired
};

export default ExportFilterModal;



// WEBPACK FOOTER //
// ./src/components/modals/ExportFilterModal.js